export const ON_LOGIN = 'ON_LOGIN';
export const ON_LOGGOUT = 'ON_LOGGOUT';
export const ON_NAVIGATE = 'ON_NAVIGATE';